/**
 * A no-op middleware
 *
 * @returns  {Promise}  A resolved promise
 */
module.exports = function() {
    return Promise.resolve();
};
